import _ from 'lodash';
import React from 'react';

import { errorUtil } from 'iron-forge-react-modules';
import { SelectItemsModal } from 'modules';
import * as dataService from './dataService';



export interface IProps {
  storeId: string;
  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.storeId);
  const [
    saveReportingStrategy
  ] = dataService.useSaveReportingStrategiesByStore(props.storeId);



  const handleSubmit = React.useCallback(
    async (items: SelectItemsModal.IItem[]) => {
      if (_.isEmpty(items)) {
        window.alert("Must select at least 1 item.");
        return;
      }

      if (window.confirm(`Are you sure you want to add ${items.length} items to the selected store?`)) {
        await errorUtil.errorWrap(async () => {
          await saveReportingStrategy(items.map(item => ({
            itemId: item.itemId,
            priceDollars: item.defaultPriceDollars
          })));
          props.onClose();
        });
      }
    },
    [
      props,
      saveReportingStrategy
    ]
  );



  const selectedItemIds = React.useMemo(
    () => queryTuple.data.items.map(item => item.itemId),
    [queryTuple]
  );

  return (
    <SelectItemsModal.FC
      canBeManagedByStoreId={props.storeId}
      selectedItemIds={selectedItemIds}
      onClose={props.onClose}
      onSubmit={handleSubmit} />
  );
};
